import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, faClipboardList, faMoneyCheckAlt, 
  faMoneyBillWave, faHandsHelping, faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry, faWallet, faSearch, faClockRotateLeft, faClipboardQuestion, faCertificate, faToolbox, 
  faQuestionCircle,
  faBrain
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import bluehandsimage from '../../assets/gdashboard/AgriJobs.png';
import Tooltip from '../../components/utils/Tooltip';

function AgriJobsHome() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [category, setCategory] = useState("Labour");
  const [searchCity, setSearchCity] = useState("Mumbai");
  const [customCity, setCustomCity] = useState("");
  const [jobsData, setJobsData] = useState([]);
  const [isInstant, setIsInstant] = useState(false);
  const [error, setError] = useState(null);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [applyRemarks, setApplyRemarks] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [shortlistedRemarks, setShortlistedRemarks] = useState("");

  const fetchJobs = useCallback(() => {
    const config = {
      url: "/bluejobs/jobs",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userId: userId, 
        searchKeyword: searchKeyword, 
        category: category, 
        searchCity: searchCity, 
        customCity: customCity,
        isInstant: isInstant
      },
    };
    // console.log(config);
    // setJobsData();

    fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log(data.jobsData);
        if (data && data.jobsData) {
          setJobsData(data.jobsData);
        } else {
          console.error("Data not found!!");
          setJobsData([]); 
        }
      })
      .catch((error) => {
        console.error("Error fetching Job data:", error);
        setJobsData([]); 
      });
  }, [
    authState.userId, 
    authState.token,
    searchCity,
    customCity,
    isInstant,
    searchKeyword,
    category,
    fetchData
  ]);

  // useEffect(() => {
  //   if (authState.isLoggedIn) {
  //     fetchJobs();
  //   }
  // }, [authState.isLoggedIn]);

  const handleView = (jobId) => {
    setSelectedJobId(prevId => (prevId === jobId ? null : jobId));
  };

  const handleJobShare = (jobId) => {
    setSelectedJobId(jobId);
  };

  const handleJobSave = (jobId) => {
    setSelectedJobId(jobId);
  };

  // const handleJobApply(jobid, jobcode, postedby){
  //   setSelectedJobId(jobid);
  //   applyJob(jobcode, jobid, postedby);
  // };

  const handleJobApply = useCallback(
    (jobcode, jobid, postedby) => {
      const config = {
        url: "/bluejobsapply/apply",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
          userId,
          userCode: authState.user.think5whyscode,
          jobCode: jobcode,
          jobId: jobid,
          postedBy: postedby,
          applyDate: new Date(),
          applyRemarks, 
          isWithdraw: false,
          reviewerId: null,
          reviewerCode: '',
          reviewDate: null,
          reviewRemarks: '',
          reviewStatus: '',
          isHide: false,
        },
      };
  
      fetchData(config, { showSuccessToast: false })
        .then((response) => {
          setApplied(true); // Update UI to indicate the job has been applied
        })
        .catch((error) => {
          console.error("Error applying this job:", error);
        });
    },
    [authState.token, authState.user.think5whyscode, userId, fetchData]
  );
  

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const formatDate = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [shortlisted, setShortlisted] = useState(false);
  const saveShortlist = useCallback(
    (jobid, jobcode, jobtitle, employername, postedby,  posteddate) => {
      const config = {
        url: "/bluejobsshortlisted/shortlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
          userId: userId,
          userCode: userCode,
          jobCode: jobcode,
          jobId: jobid,
          jobTitle: jobtitle,
          jobPostedBy: postedby,
          postedDate: posteddate,
          employerName: employername,
          shortlistedDate: new Date(),
          shortlistedRemarks, 
          isActive: true,
        },
      };
  
      fetchData(config, { showSuccessToast: false })
        .then((response) => {
          setShortlisted(true); 
        })
        .catch((error) => {
          setShortlisted(false);
          console.error("Error applying this job:", error);
        });
    },
    [authState.token, userId, fetchData]
  );
  
  const [applied, setApplied] = useState(false);
  const saveApply = useCallback(
    (jobid, jobcode, jobtitle, employername, postedby,  posteddate) => {
      // console.log(jobid, jobcode, jobtitle, employercode, postedby,  posteddate);

      const config = {
        url: "/bluejobsapply/apply",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
          userId,
          userCode,
          jobCode: jobcode,
          jobTitle: jobtitle,
          jobId: jobid,
          jobPostedBy: postedby,
          postedDate: posteddate,
          employerName: employername,
          applyDate: new Date(),
          applyRemarks, 
          isWithdraw: false,
          reviewerId: null,
          reviewerCode: '',
          reviewDate: null,
          reviewRemarks: '',
          reviewStatus: '',
          isHide: false,
        },
      };
  
      fetchData(config, { showSuccessToast: false })
        .then((response) => {
          setApplied(true); 
        })
        .catch((error) => {
          console.error("Error applying this job:", error);
        });
    },
    [authState.token, userId, fetchData]
  );
  // const sortedJobs = [...jobs].sort((a, b) => new Date(b.applyFromDate) - new Date(a.applyFromDate));

  const JobList = ({ jobs, category, isInstant, searchKeyword, searchCity, customCity }) => (
    <div className='flex flex-col items-center justify-center'>
      <p className="text-yellow-200 text-lg">
        {jobs.length} {category} {isInstant ? "Instant" : "Regular"} Jobs Found for {searchKeyword} in {searchCity} {customCity}
      </p>
      {jobs.map((job, index) => (
        <JobCard
          key={job._id}
          job={job}
          index={index}
          selectedJobId={selectedJobId}
          onView={handleView}
        />
      ))}
    </div>
  );
  
  const JobCard = ({ job, index, selectedJobId, onView, onShare, onSave, onApply }) => (
    <div className="bg-white my-1 p-1 text-gray-600 rounded-md shadow-md text-sm">
      <div className="flex">
        <span className="text-m">
          {index + 1}. {job.jobTitle}, ({formatDateTime(job.datePosted)})
        </span>
        <Tooltip text="View details" position="top">
          <span className="ml-auto mr-4 text-blue-500 cursor-pointer" onClick={() => onView(job._id)}>
            <i className="fa-solid fa-eye"></i>
          </span>
        </Tooltip>
      </div>
      {selectedJobId === job._id && (
        <JobDetails job={job} onShare={onShare} onSave={onSave} onApply={onApply} />
      )}
    </div>
  );
  
  const JobDetails = ({ job, onShare, onSave, onApply }) => (
    <div className="bg-gray-600 text-white px-4 py-4">
      <h2 className="text-yellow-200 text-lg"><strong>Job Details of {job.jobTitle}</strong></h2>
      <p><strong>Job Code:</strong> {job.jobCode}</p>
      {/* <p><strong>Job Title:</strong> {job.jobTitle}</p> */}
      <p><strong>Location:</strong> {job.jobLocation}</p>
      <p><strong>Category:</strong> {job.jobCategory}</p>
      <p><strong>Description:</strong> {job.jobDescription}</p>
      <p><strong>Vacancies:</strong> {job.vacancies}</p>
      <p><strong>Salary Details:</strong> {job.salaryDetails}</p>
      <p><strong>Remarks:</strong> {job.splRemarks}</p>
      <p><strong>Employer:</strong> {job.employerName}</p>
      <p>{job.employerDetails}</p>
      <p>{job.employerAddress}</p>
      <p><strong>Department:</strong> {job.department}</p>
      <p><strong>Application Period:</strong> {formatDate(job.applyFromDate)}{' to '}{formatDate(job.applyToDate)}</p>
      <p><strong>Date Posted:</strong> {formatDate(job.datePosted)}</p>
      <div className="mb-2 text-sm">
        <button
            className='bg-purple-700 mt-2'
            onClick={() => saveShortlist(job._id, job.jobCode, job.jobTitle, job.employerName, job.createdBy, job.datePosted)}
            disabled={shortlisted}
            style={{ width: '150px', height: '36px'}}
          >
            Shortlist
        </button>
        <button
            className='bg-purple-700 mt-2 ml-4'
            onClick={() => saveApply(job._id, job.jobCode, job.jobTitle, job.employerName, job.createdBy, job.datePosted)}
            disabled={applied}
            style={{ width: '150px', height: '36px'}}
          >
            Apply
        </button>
      </div>
      { shortlisted && (
          <div className="mb-2 text-white">
              {shortlisted ? 
                <p className='text-lg text-green-400'>You Have Shortlisted The Job!</p>
              : <p className='text-lg text-red-500'>Failed To Shorlist!</p>
              }
          </div>
      )}
      { applied && (
          <div className="mb-2 text-white">
              {applied ? "Yes" : "No"}
              {applied ? 
                <p className='text-lg text-green-400'>You Have Successfully Applied For The Job!</p>
              : <p className='text-lg text-red-500'>Failed To Apply!</p>
              }
          </div>
      )}
      <div className="flex mt-2">
        <Tooltip text="Share" position="top">
          <span className="text-green-500 cursor-pointer mr-4" onClick={() => onShare(job._id)}>
            <i className="fa-solid fa-share"></i>
          </span>
        </Tooltip>
        <Tooltip text="Shortlist" position="top">
          <span className="text-blue-500 cursor-pointer mr-4" onClick={() => onSave(job._id)}>
            <i className="fa-solid fa-save"></i>
          </span>
        </Tooltip>
        <Tooltip text="Apply" position="top">
          <span className="text-orange-500 cursor-pointer mr-4" onClick={() => onApply(job._id)}>
            <i className="fa-solid fa-print"></i>
          </span>
        </Tooltip>
      </div>
    </div>
  );
  
  const NoJobsMessage = ({ isInstant, category, searchKeyword, searchCity, customCity }) => (
    <p className="text-yellow-300">
      No {isInstant ? "Instant" : "Regular"} {category} Jobs Found for {searchKeyword} in {searchCity} {customCity}
    </p>
  );
  
  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-black border border-green-300 mt-4">
        <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-4'>AgriJobs@Think5Whys</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-4 mt-4 border-2 border-green-200 rounded-md p-6">
            <div className="flex flex-row items-center justify-center w-full p-2">
              <FontAwesomeIcon icon={faSearch} className="text-yellow-200 text-xs ml-2 w-8 h-8 flex-shrink-0" />
              <input
                type="text"
                placeholder="Enter Keywords eg Worker, Gardener, Grwer, Manager etc"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="ml-4 h-10 text-sm border border-gray-300 rounded-md px-4 py-2 flex-grow min-w-0 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className='flex flex-row mt-4'>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px', width: "300px" }}
              >
                <option value="">Select an Agriculture Job Category</option>

                <optgroup label="Crop Production & Cultivation">
                  <option value="Farm Labourer">Farm Labourer</option>
                  <option value="Crop Supervisor">Crop Supervisor</option>
                  <option value="Seedling Grower">Seedling Grower</option>
                  <option value="Pesticide Sprayer">Pesticide Sprayer</option>
                  <option value="Irrigation Technician">Irrigation Technician</option>
                </optgroup>

                <optgroup label="Horticulture & Plantation">
                  <option value="Gardener">Gardener</option>
                  <option value="Orchard Worker">Orchard Worker</option>
                  <option value="Floriculture Assistant">Floriculture Assistant</option>
                  <option value="Tea & Coffee Plantation Worker">Tea & Coffee Plantation Worker</option>
                  <option value="Nursery Manager">Nursery Manager</option>
                </optgroup>

                <optgroup label="Dairy, Poultry & Livestock">
                  <option value="Dairy Worker">Dairy Worker</option>
                  <option value="Poultry Farm Assistant">Poultry Farm Assistant</option>
                  <option value="Veterinary Assistant">Veterinary Assistant</option>
                  <option value="Animal Feeder">Animal Feeder</option>
                  <option value="Milk Collection Operator">Milk Collection Operator</option>
                </optgroup>

                <optgroup label="Agri-Processing & Value Addition">
                  <option value="Food Processing Assistant">Food Processing Assistant</option>
                  <option value="Packaging & Grading Worker">Packaging & Grading Worker</option>
                  <option value="Cold Storage Operator">Cold Storage Operator</option>
                  <option value="Milling Machine Operator">Milling Machine Operator</option>
                  <option value="Agro Product Sorter">Agro Product Sorter</option>
                </optgroup>

                <optgroup label="Fisheries & Aquaculture">
                  <option value="Fish Farm Worker">Fish Farm Worker</option>
                  <option value="Aquaculture Technician">Aquaculture Technician</option>
                  <option value="Fishing Assistant">Fishing Assistant</option>
                  <option value="Fish Feed Processor">Fish Feed Processor</option>
                </optgroup>

                <optgroup label="Agri Machinery & Mechanization">
                  <option value="Tractor Operator">Tractor Operator</option>
                  <option value="Farm Equipment Mechanic">Farm Equipment Mechanic</option>
                  <option value="Drone Operator">Drone Operator</option>
                  <option value="Irrigation Pump Operator">Irrigation Pump Operator</option>
                </optgroup>

                <optgroup label="Rural Development & Allied Services">
                  <option value="Agri Field Coordinator">Agri Field Coordinator</option>
                  <option value="Self Help Group Facilitator">Self Help Group Facilitator</option>
                  <option value="Farm Data Collector">Farm Data Collector</option>
                  <option value="Village Resource Person">Village Resource Person</option>
                  <option value="Agri Extension Assistant">Agri Extension Assistant</option>
                </optgroup>

                <optgroup label="Forestry & Environment">
                  <option value="Forest Worker">Forest Worker</option>
                  <option value="Tree Plantation Labourer">Tree Plantation Labourer</option>
                  <option value="Watershed Technician">Watershed Technician</option>
                  <option value="Organic Farming Promoter">Organic Farming Promoter</option>
                </optgroup>

                <optgroup label="Handicrafts & Cottage Industries">
                  <option value="Handloom Weaver">Handloom Weaver</option>
                  <option value="Bamboo Craft Worker">Bamboo Craft Worker</option>
                  <option value="Pottery Artisan">Pottery Artisan</option>
                  <option value="Jute Product Maker">Jute Product Maker</option>
                </optgroup>

                <optgroup label="Rural Logistics & Support">
                  <option value="Agri Produce Transporter">Agri Produce Transporter</option>
                  <option value="Market Yard Assistant">Market Yard Assistant</option>
                  <option value="Warehouse Operator">Warehouse Operator</option>
                  <option value="Cold Chain Handler">Cold Chain Handler</option>
                </optgroup>

                <optgroup label="Agri Entrepreneurs & Professionals">
                  <option value="Agri Entrepreneur">Agri Entrepreneur</option>
                  <option value="Input Dealer">Input Dealer</option>
                  <option value="Farm Consultant">Farm Consultant</option>
                  <option value="Agri Startup Founder">Agri Startup Founder</option>
                  <option value="Cooperative Manager">Cooperative Manager</option>
                </optgroup>

              </select>
              <select
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
                className="ml-4 border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="">Select Your Agri Zone / District</option>

                <optgroup label="Northern India">
                  <option value="Karnal (Haryana)">Karnal (Haryana)</option>
                  <option value="Ludhiana (Punjab)">Ludhiana (Punjab)</option>
                  <option value="Bareilly (Uttar Pradesh)">Bareilly (Uttar Pradesh)</option>
                  <option value="Dehradun (Uttarakhand)">Dehradun (Uttarakhand)</option>
                  <option value="Gorakhpur (Uttar Pradesh)">Gorakhpur (Uttar Pradesh)</option>
                </optgroup>

                <optgroup label="Western India">
                  <option value="Ahmednagar (Maharashtra)">Ahmednagar (Maharashtra)</option>
                  <option value="Nashik (Maharashtra)">Nashik (Maharashtra)</option>
                  <option value="Surat (Gujarat)">Surat (Gujarat)</option>
                  <option value="Rajkot (Gujarat)">Rajkot (Gujarat)</option>
                  <option value="Udaipur (Rajasthan)">Udaipur (Rajasthan)</option>
                </optgroup>

                <optgroup label="Central India">
                  <option value="Indore (Madhya Pradesh)">Indore (Madhya Pradesh)</option>
                  <option value="Jabalpur (Madhya Pradesh)">Jabalpur (Madhya Pradesh)</option>
                  <option value="Raipur (Chhattisgarh)">Raipur (Chhattisgarh)</option>
                  <option value="Bilaspur (Chhattisgarh)">Bilaspur (Chhattisgarh)</option>
                </optgroup>

                <optgroup label="Eastern India">
                  <option value="Purnea (Bihar)">Purnea (Bihar)</option>
                  <option value="Muzaffarpur (Bihar)">Muzaffarpur (Bihar)</option>
                  <option value="Cuttack (Odisha)">Cuttack (Odisha)</option>
                  <option value="Purulia (West Bengal)">Purulia (West Bengal)</option>
                  <option value="Sundargarh (Odisha)">Sundargarh (Odisha)</option>
                </optgroup>

                <optgroup label="Southern India">
                  <option value="Thanjavur (Tamil Nadu)">Thanjavur (Tamil Nadu)</option>
                  <option value="Madurai (Tamil Nadu)">Madurai (Tamil Nadu)</option>
                  <option value="Kurnool (Andhra Pradesh)">Kurnool (Andhra Pradesh)</option>
                  <option value="Warangal (Telangana)">Warangal (Telangana)</option>
                  <option value="Shimoga (Karnataka)">Shimoga (Karnataka)</option>
                </optgroup>

                <optgroup label="North-Eastern India">
                  <option value="Dibrugarh (Assam)">Dibrugarh (Assam)</option>
                  <option value="Imphal (Manipur)">Imphal (Manipur)</option>
                  <option value="Aizawl (Mizoram)">Aizawl (Mizoram)</option>
                  <option value="Agartala (Tripura)">Agartala (Tripura)</option>
                  <option value="Kohima (Nagaland)">Kohima (Nagaland)</option>
                </optgroup>

                <option value="">Other Location</option>

              </select>
            </div>
            { searchCity === "" && (
              <div className='mt-4'>
                <input
                  type="text"
                  placeholder="Enter location"
                  value={customCity}
                  onChange={(e) => setCustomCity(e.target.value)}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style= {{width: "300px"}}
                />
              </div>
            )}
            <div className="flex items-center">
              <input 
                type="checkbox" 
                className="mr-2 cursor-pointer accent-blue-600 focus:ring-2 focus:ring-blue-500"
                checked={isInstant} 
                onChange={(e) => setIsInstant(e.target.checked)} 
              />
              <span className="text-m font-medium text-white">Get Instant Job</span>
            </div>
            <div className="flex flex-row items-center justify-center gap-x-4 h-10 mt-4">
              <button
                onClick={() => fetchJobs()} 
                className="bg-blue-800 text-white w-40 h-10 flex items-center justify-center rounded-md hover:bg-blue-900 transition"
              >
                Search
              </button>
            </div>

            {/* <div className="px-2 py-2 flex flex-row justify-center items-center">
                
              </div> */}
            <div className='w-full text-m flex flex-col justify-center'>
            {jobsData.length > 0 ? (
              <JobList
                jobs={jobsData}
                category={category}
                isInstant={isInstant}
                searchKeyword={searchKeyword}
                searchCity={searchCity}
                customCity={customCity}
              />
            ) : (
              <NoJobsMessage
                isInstant={isInstant}
                category={category}
                searchKeyword={searchKeyword}
                searchCity={searchCity}
                customCity={customCity}
              />
            )}
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardAILink to="/aicounselling-about" icon={faQuestionCircle} text="About AI Counselling" />
            <CardAILink to="/aicounselling-job" icon={faBrain} text="Job AI Counsellor" />
            <CardLink to="/bluehands-shortlisted" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardLink to="/bluehands-applied" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardLink to="/bluehands-applied" icon={faEye} text="Who Shortlisted Me" />
            <CardLink to="/bluehands-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardSkillLink to="/training-list" icon={faToolbox} text="My Skill Trainings" />
            <CardSkillLink to="/my-certificates-others" icon={faCertificate} text="My Skill Certificates" />
            <CardProfileLink to="/myprofile-blueprofile" icon={faUser} text="My Blue Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/blue" icon={faIdCard} text="My Secure Blue Card" />
            <CardLink to={`/pub/blue/${userCode}`} icon={faLockOpen} text="My Public Blue Card" />
            <CardLink to="/attendance-list" icon={faClock} text="My Attendance" />
            <CardLink to="/myjournal/2" icon={faBook} text="My Work Diary" />
            <CardLink to="/jobless-list" icon={faSadCry} text="My Joblessness History" />
            <CardLink to="/salary-list" icon={faMoneyBillWave} text="My Salary & Wages" />
            <CardProfileLink to="/bluehands-mybiodata" icon={faUser} text="Write My Bio-Data" />
            <CardProfileLink to="/visualbrief-myvb" icon={faUser} text="My Multimedia Profile" />
            <CardProfileLink to="/visualbrief-myvb" icon={faUser} text="My Work Presentations" />
            <CardProfileLink to="/visualbrief-myvb" icon={faUser} text="My Creativity Presentations" />
            <CardLink to="/thinkaiinterview-mock" icon={faUser} text="ThinkAIInterviewer Mock" />
            <CardNoLink to="" icon={faUser} text="ThinkAIInterviewer Job" />
            <CardAdminLink to="/bluehands-myjobpost-list" icon={faClock} text="Job Postings" />
            <CardAdminLink to="/attendance-capture-qr" icon={faImage} text="Attendance Locations" />
            <CardNoLink to="" icon={faClipboardList} text="Employee Muster Roll" />
            <CardAdminLink to="/bluehands-my" icon={faUsers} text="My AgriJobs" />
            <CardLink to="/agrijobs-pricelist" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardAILink Component
const CardAILink = ({ to, icon, text }) => (
  <div className="bg-purple-600 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-yellow-200">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardSkillLink Component
const CardSkillLink = ({ to, icon, text }) => (
  <div className="bg-teal-600 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-yellow-200">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardAdminLink Component
const CardAdminLink = ({ to, icon, text }) => (
  <div className="bg-orange-600 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-yellow-200">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardProfileLink Component
const CardProfileLink = ({ to, icon, text }) => (
  <div className="bg-blue-800 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-yellow-200">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default AgriJobsHome;




